import { render, staticRenderFns } from "./LazyLoader.vue?vue&type=template&id=1cc3f3f2&scoped=true&"
import script from "./LazyLoader.vue?vue&type=script&lang=ts&"
export * from "./LazyLoader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc3f3f2",
  null
  
)

export default component.exports